module.exports = __webpack_public_path__ + "img/felix_gumbsch_8.b0322ab7.jpg";